export default photoId => {
  if (photoId) {
    return `/api/files/${photoId}/`
  } else {
    return null
  }
}
